import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from '../SignInPage/types'
import * as profileActions from '../SignInPage/actions'
import { Link } from 'react-router-dom'
import { checkProfileRole } from '../../utils/helpers'
import notification from '../../components/Notification'
import usePrevious from '../../hooks/usePrevious'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import ProfileHeader from '../../components/ProfileHeader'
import PersonalEditBlock from '../../components/PersonalEditBlock'
import EducationEditBlock from '../../components/EducationEditBlock'
import AwardsEditBlock from '../../components/AwardsEditBlock'
import AvatarEditBlock from '../../components/AvatarEditBlock'
import ContactsEditBlock from '../../components/ContactsEditBlock'
import AboutEditBlock from '../../components/AboutEditBlock'
import ModalInvite from '../../components/ModalInvite'
import ModalChangeRole from '../../components/ModalChangeRole'

// Icons
import IconAdmin from './images/iconAdmin'

// Styles
import './styles.scss'

export default () => {
  const initialModalChangeRole: {
    modal: boolean
    type: 'teacher' | 'student'
  } = {
    modal: false,
    type: 'teacher',
  }

  const [modalInviteFriend, setModalInviteFriend] = useState<boolean>(false)
  const [modalChangeRole, setModalChangeRole] = useState<
    typeof initialModalChangeRole
  >(initialModalChangeRole)
  const dispatch = useDispatch()

  const {
    profile,
    certificates,
    isProcessChangeProfileRole,
    isFetchingCertificates,
    error,
  } = useSelector((state: { profile: InitialState }) => state.profile)

  const prevChangeProfileRole = usePrevious(isProcessChangeProfileRole)

  useEffect(() => {
    dispatch(profileActions.fetchProfile())
  }, [])

  useEffect(() => {
    if (error) {
      notification('error', 'Ошибка', error)
      dispatch(profileActions.clearError())
    }
  }, [error])

  useEffect(() => {
    if (prevChangeProfileRole === true && !isProcessChangeProfileRole) {
      dispatch(profileActions.fetchProfile())
      setModalChangeRole(initialModalChangeRole)
    }
  }, [isProcessChangeProfileRole])

  const isAdministrator = checkProfileRole(profile?.roles, 'administrator')
  const isStudent = checkProfileRole(profile?.roles, 'student')
  const isTeacher = checkProfileRole(profile?.roles, 'teacher')

  const saveProfile = (data: object) => {
    dispatch(profileActions.saveProfile(data))
  }

  const handleUploadPhoto = (photo: File) => {
    dispatch(profileActions.uploadPhoto(photo))
  }

  const handlePhotoRemove = () => {
    dispatch(profileActions.removePhoto())
  }

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 40 }} />
          {profile ? (
            <>
              <div className={'profile-edit-container'}>
                <div className={'profile__edit-left'}>
                  <PersonalEditBlock
                    profile={profile.external_profile}
                    style={{ marginBottom: 40 }}
                    onSave={saveProfile}
                    typeProfile={
                      isStudent ? 'student' : isTeacher ? 'teacher' : ''
                    }
                    changeProfileRole={type =>
                      setModalChangeRole({ modal: true, type })
                    }
                    error={error}
                  />
                  <EducationEditBlock
                    onSave={saveProfile}
                    profile={profile.profile}
                    externalProfile={profile.external_profile}
                  />
                  <AwardsEditBlock
                    certificates={certificates}
                    isLoading={isFetchingCertificates}
                    style={{ marginTop: 34 }}
                  />
                </div>
                <div className={'profile__edit-right'}>
                  <AvatarEditBlock
                    style={{ marginBottom: 35 }}
                    onUpload={(photo: File) => handleUploadPhoto(photo)}
                    onRemove={handlePhotoRemove}
                    profile={profile.external_profile}
                  />
                  <ContactsEditBlock
                    style={{ marginBottom: 40 }}
                    profile={profile.external_profile}
                  />
                  <AboutEditBlock
                    profile={profile.external_profile}
                    onSave={saveProfile}
                  />
                </div>
              </div>
              <div className={'profile-buttons-container'}>
                <div className={'profile__edit-button'}>
                  <button onClick={() => setModalInviteFriend(true)}>
                    Пригласить друга
                  </button>
                </div>
                {/* <div className={'profile__edit-button'}>*/}
                {/*  <button className={'teacher'}>Пригласить учителя</button>*/}
                {/* </div>*/}
              </div>
              {isAdministrator ? (
                <Link className={'admin'} to={'/admin'}>
                  <IconAdmin />
                </Link>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
      <Footer />
      <ModalInvite
        modal={modalInviteFriend}
        typeInvite={'friend'}
        isReverse={false}
        alertDescription={'Поделитесь ей с другом!'}
        onClose={() => setModalInviteFriend(false)}
      />
      <ModalChangeRole
        modal={modalChangeRole.modal}
        type={modalChangeRole.type}
        isLoading={isProcessChangeProfileRole}
        onClose={() => setModalChangeRole(initialModalChangeRole)}
        onChangeProfileRole={() =>
          dispatch(profileActions.changeProfileRole(modalChangeRole.type))
        }
      />
    </>
  )
}
